import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthResponse, AuthService } from '../services/auth.service';
import { DEFAULT_HEADERS } from '@edt/util';
import { catchError, finalize, switchMap, throwError } from 'rxjs';
import { environment } from '@/config/runtime-config';
import { TOKEN_CTX } from '@/tokens';
import { Router } from '@angular/router';
import { NotificationService } from '@/notificaction/notification.service';

export const authBaseInterceptor: HttpInterceptorFn = (req, next) => {
  const authSrv = inject(AuthService);
  const router = inject(Router);
  const notifSrv = inject(NotificationService);

  if (!req.context.get(TOKEN_CTX)) {
    return next(req);
  }

  // const auhtHeader = req.headers.get('Authorization');
  const token: string | null | undefined = authSrv.getAuthToken();

  if (token && authSrv.isTokenExpired(token)) {
    authSrv.localLogOut();
    notifSrv.showInfo('Sesión expirada por inactividad');
    router.navigate(['/seguridad/iniciar']);
  }

  let authReq = req;
  if (
    token &&
    !authReq.url.includes('/auth/token/refresh') &&
    !authReq.url.includes('assets/')
  ) {
    authReq = addTokenHeader(req, 'Authorization', token);
  }

  return next(authReq).pipe(
    catchError(error => {
      if (
        error instanceof HttpErrorResponse &&
        !authReq.url.includes('/auth/token/refresh') &&
        !authReq.url.includes('/auth/customer/') &&
        error.status === 401
      ) {
        return handle401Error(authReq, next, error, authSrv);
      }
      return throwError(() => error as HttpErrorResponse);
    })
  );
};

export const handle401Error = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  previousError: HttpErrorResponse,
  authSrv: AuthService
) => {
  if (!authSrv.isRefreshing()) {
    const token = authSrv.getRefreshToken();
    authSrv.refreshing(true);
    if (token) {
      return authSrv
        .refreshToken<AuthResponse>(
          {
            url: `${environment.baseApiUrl}/auth/token/refresh`,
            headers: { ...DEFAULT_HEADERS, Authorization: `Bearer ${token}` },
          },
          { token }
        )
        .pipe(
          switchMap(tokenRep => {
            authSrv.refreshing(false);
            return next(
              addTokenHeader(request, 'Authorization', tokenRep.access)
            );
          }),
          catchError(err => {
            authSrv.refreshing(false);
            authSrv.localLogOut(); // TODO: hacer logout
            return throwError(() => err as HttpErrorResponse);
          }),
          finalize(() => {
            authSrv.refreshing(false);
          })
        );
    }
    return throwError(() => previousError);
  }

  /* return authSrv.refresh$.pipe(
    filter(token => (token && token !== 'NO_TOKEN' ? true : false)),
    take(1),
    switchMap(token =>
      next(addTokenHeader(request, env.tokenHeaderKey, token ?? 'NO_TOKEN'))
    )
  ); */
  const token = authSrv.getAuthToken() ?? 'NO_TOKEN';
  return next(addTokenHeader(request, 'Authorization', token ?? 'NO_TOKEN'));
};

export const addTokenHeader = (
  request: HttpRequest<unknown>,
  tokenHeader: string,
  token: string
) => {
  return request.clone({
    headers: request.headers.set(tokenHeader, 'Bearer ' + token),
  });
};
